import Box from '@eversports/klimt-primitives/legacy/Box'
import { motion } from '@eversports/klimt-utilities/framer-motion'

import usePrefersReducedMotion from '../../../../hooks/use-prefers-reduced-motion'

import GiftBoxSvg from './assets/gift-box-icon.svg'
import GiftBoxShadowSvg from './assets/gift-box-shadow-icon.svg'
import SparkleSvg from './assets/sparkle-icon.svg'

const LOOP_DURATION_SECONDS = 2
const INFINITE_EASE_IN_OUT_TRANSITION = {
  duration: LOOP_DURATION_SECONDS,
  times: [0, 0.5, 1],
  ease: 'easeInOut',
  repeat: Infinity,
} as const
// Users who asked for reduced motion get the resting frame of the animation instead of the loop.
const STILL_TRANSITION = { duration: 0 } as const

interface SparkleConfig {
  top: number
  left: number
  size: number
  opacity: Array<number>
  scale: Array<number>
  times: Array<number>
  ease: Array<string>
}

const TWINKLE_LEAD_IN = { opacity: [0.3, 1, 0.3, 0.3], scale: [0.5, 1, 0.5, 0.5] }
const TWINKLE_LEAD_IN_EASE = ['easeInOut', 'easeInOut', 'linear']
const TWINKLE_HOLD = { opacity: [0.3, 0.3, 1, 0.3, 0.3], scale: [0.5, 0.5, 1, 0.5, 0.5] }
const TWINKLE_HOLD_EASE = ['linear', 'easeInOut', 'easeInOut', 'linear']

const SPARKLES: Array<SparkleConfig> = [
  { top: 43, left: 0, size: 14, ...TWINKLE_LEAD_IN, times: [0, 0.3, 0.6, 1], ease: TWINKLE_LEAD_IN_EASE },
  { top: 53, left: 141, size: 16, ...TWINKLE_LEAD_IN, times: [0, 0.3, 0.6, 1], ease: TWINKLE_LEAD_IN_EASE },
  { top: 0, left: 142, size: 8, ...TWINKLE_HOLD, times: [0, 0.15, 0.45, 0.75, 1], ease: TWINKLE_HOLD_EASE },
  { top: 7, left: 113, size: 7, ...TWINKLE_HOLD, times: [0, 0.15, 0.45, 0.75, 1], ease: TWINKLE_HOLD_EASE },
  { top: 98, left: 3, size: 7, ...TWINKLE_HOLD, times: [0, 0.3, 0.6, 0.9, 1], ease: TWINKLE_HOLD_EASE },
  { top: 104, left: 137, size: 8, ...TWINKLE_HOLD, times: [0, 0.075, 0.375, 0.675, 1], ease: TWINKLE_HOLD_EASE },
  { top: 1, left: 6, size: 8, ...TWINKLE_HOLD, times: [0, 0.225, 0.525, 0.825, 1], ease: TWINKLE_HOLD_EASE },
]

export function VoucherGiftAnimation() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <Box sx={{ position: 'relative', width: 156, height: 134 }}>
      <motion.div
        style={{ position: 'absolute', top: 118, left: 35, width: 72, height: 16 }}
        initial={{ opacity: 1, scale: 1 }}
        animate={prefersReducedMotion ? { opacity: 1, scale: 1 } : { opacity: [1, 0.6, 1], scale: [1, 0.92, 1] }}
        transition={prefersReducedMotion ? STILL_TRANSITION : INFINITE_EASE_IN_OUT_TRANSITION}
      >
        <img src={GiftBoxShadowSvg} width={72} height={16} alt="" />
      </motion.div>
      <motion.div
        style={{
          position: 'absolute',
          top: 5,
          left: 24,
          width: 101,
          height: 104,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        initial={{ y: 0 }}
        animate={prefersReducedMotion ? { y: 0 } : { y: [0, -8, 0] }}
        transition={prefersReducedMotion ? STILL_TRANSITION : INFINITE_EASE_IN_OUT_TRANSITION}
      >
        <div style={{ transform: 'rotate(2.85deg)' }}>
          <img src={GiftBoxSvg} width={96} height={100} alt="" />
        </div>
      </motion.div>
      {SPARKLES.map(({ top, left, size, opacity, scale, times, ease }, index) => (
        <motion.div
          key={index}
          style={{ position: 'absolute', top, left, width: size, height: size }}
          initial={{ opacity: opacity[0], scale: scale[0] }}
          animate={prefersReducedMotion ? { opacity: 1, scale: 1 } : { opacity, scale }}
          transition={
            prefersReducedMotion ? STILL_TRANSITION : { duration: LOOP_DURATION_SECONDS, times, ease, repeat: Infinity }
          }
        >
          <img src={SparkleSvg} width={size} height={size} alt="" />
        </motion.div>
      ))}
    </Box>
  )
}
